import React, {Component} from "react";
import { withRouter } from 'react-router';

class InformationBox extends Component {
    constructor(props){
        super(props);
        this.closeModalHandler = this.closeModalHandler.bind(this);
    }

    closeModalHandler() {
        this.props.toggleInformationBox();
    }

    handleModalClick(e) {
        e.stopPropagation();
    }
    
    render() {
        if(!this.props.showInformationBox){
            return null;
        }
        return(
            <div className="RatingModal" onClick={this.closeModalHandler}>
                <div style={{height: "unset", margin: "auto"}} onClick={(e) => this.handleModalClick(e)} className="SuccessModalContainer">
                   <div style={{width: "100%", textAlign: "center", fontFamily: "Poppins-Regular", padding: "30px 30px"}}>{this.props.infoText}</div>
                   <div style={{padding: "0px 0px 30px 0px", display: "flex", flexDirection: "row", width: "100%"}}>
                        <div style={{width: "100%", paddingLeft: "150px", paddingRight: "150px"}}>
                            <div onClick={this.closeModalHandler} style={{width: "100%", backgroundColor: "#EA5B2F", border: "1px solid #EA5B2F", textAlign: "center", padding: "12px 0px", color: "white", borderRadius: "20px", cursor: "pointer"}}>
                                Ok
                            </div>
                        </div>
                   </div>
                </div>
            </div>
        )
    }
}

export default withRouter(InformationBox);